import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const MitigationDonutChart = ({ graphData }) => {
  const [data, setData] = useState(graphData ?? []);

  // Total mitigations and overall progress
  const totalMitigations = 18;
  const overallProgress = 11.11; // Rounded from 11.11111111111111

  // Highcharts options configuration
  const options = {
    chart: {
      type: "pie",
    },
    title: {
      text: "Mitigation Status Overview",
    },
    tooltip: {
      pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
    },
    accessibility: {
      point: {
        valueSuffix: "%",
      },
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: true,
          format: "<b>{point.name}</b>: {point.percentage:.1f} %",
        },
        showInLegend: true,
        innerSize: "60%", // To create the donut effect
      },
    },
    series: [
      {
        name: "Mitigation Status",
        colorByPoint: true,
        data: data,
      },
    ],
    // Add overall progress in the center of the donut
    credits: {
      enabled: false, // Remove highcharts.com watermark
    },
  };

  useEffect(() => {
    setData(graphData);
  }, [graphData]);

  return (
    <div style={{ position: "relative" }}>
      <HighchartsReact highcharts={Highcharts} options={options} />
      {/* Show total mitigations and progress inside the donut */}
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          textAlign: "center",
          fontSize: "12px",
          fontWeight: "bold",
        }}
      >
        <div>Total: {totalMitigations}</div>
        <div>Progress: {overallProgress}%</div>
      </div>
    </div>
  );
};

export default MitigationDonutChart;
